import { PageWrapper } from '@approvalmax/ui/src/components';
import { PageRoute } from 'app/resources/components';
import { hocs as pageHocs } from 'modules/page';
import { memo } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';
import { getPath, Path } from 'urlBuilder';

import { useBreadcrumbs } from '../resources/hooks/useBreadcrumbs';
import ApprovedPage from './(status)/approved';
import IncompletePage from './(status)/incompleted';
import RejectedPage from './(status)/rejected';
import StartPage from './(status)/start';
import SubmittedPage from './(status)/submitted';
import { pageConfig } from './config';
import { Loading } from './loading';
import { useKycInitialRedirection } from './resources/hooks/useKycInitialRedirection';
import { messages } from './resources/messages';

const Page = memo(() => {
    useBreadcrumbs();

    const company = useCompanyBasedOnUrl();
    const { isFetching } = useKycInitialRedirection();

    return (
        <>
            <Helmet title={messages.title({ companyName: company?.displayName })} />

            <PageWrapper color='midnight30'>
                <PageWrapper.Content>
                    {isFetching ? (
                        <Loading />
                    ) : (
                        <Switch>
                            <PageRoute exact path={StartPage.path} component={StartPage.component} />

                            <PageRoute path={ApprovedPage.path} component={ApprovedPage.component} />

                            <PageRoute path={IncompletePage.path} component={IncompletePage.component} />

                            <PageRoute path={SubmittedPage.path} component={SubmittedPage.component} />

                            <PageRoute path={RejectedPage.path} component={RejectedPage.component} />

                            <Route path='*'>
                                <Redirect to={getPath(Path.walletsKyc, company.id)} />
                            </Route>
                        </Switch>
                    )}
                </PageWrapper.Content>
            </PageWrapper>
        </>
    );
});

export default pageHocs.withProtected({ Page, roles: pageConfig.access });
